/* eslint-disable @typescript-eslint/no-explicit-any */
import useGetMortgageCompanies from '@/hooks/useGetMortgageCompanies';
import { Dispatch, FC, SetStateAction } from 'react';
import EditRecordModal from './EditRecordModal';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  agent: any;
  columns: string[];
}

const LoanOfficerFormModal: FC<Props> = ({
  agent,
  isOpen,
  setIsOpen,
  columns,
}) => {
  const { data: mortgageCompanies } = useGetMortgageCompanies();

  return (
    <EditRecordModal
      record={agent}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      selectField={{
        label: 'Mortgage Company',
        placeholder: 'Select Mortgage Company',
        fieldKey: 'mortgageId',
        items: mortgageCompanies?.map((c) => ({
          label: c.name,
          value: c._id,
        })),
        defaultValue: agent?.mortgageId || '',
      }}
      successMessage="Successfully Edited Loan Officer"
    />
  );
};

export default LoanOfficerFormModal;
